import React, { FC, ReactNode, useEffect, useState } from 'react';
import { DashboardContext } from './context';
import { CoKitchenType } from 'utils/types';
import { LEKKI_COKITCHEN, STORAGE_KEYS } from 'utils/constants';
import { apiService } from 'services/base.service';
import { PolygonType } from 'models/polygon.model';
import { handleApiError } from 'utils/functions';

const DashboardProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [searchValue, setSearchValue] = useState('');
  const [activeCokitchen, setActiveCokitchen] = useState({} as CoKitchenType);
  const [rightSection, setRightSection] = useState<ReactNode>();
  const [isRightSectionWide, setIsRightSectionWide] = useState(false);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [cokitchens, setCokitchens] = useState<CoKitchenType[]>([]);
  const [polygons, setPolygons] = useState<PolygonType[]>([]);
  const [showStudentAmbassadorModal, setShowStudentAmbassadorModal] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const activeCokitchen = localStorage.getItem(STORAGE_KEYS.ACTIVE_COKITCHEN);
    const defaultCokitchen = cokitchens.find((c) => c.name === LEKKI_COKITCHEN) ?? cokitchens[0];
    const active = activeCokitchen ? JSON.parse(activeCokitchen) : defaultCokitchen;
    setActiveCokitchen(active);
  }, [cokitchens]);

  useEffect(() => {
    if (!activeCokitchen?.id) return;
    localStorage.setItem(STORAGE_KEYS.ACTIVE_COKITCHEN, JSON.stringify(activeCokitchen));
  }, [activeCokitchen]);

  const loadPolygons = async (ids: string[]) => {
    try {
      const res = await apiService.post(`marketing/cokitchen-polygon/fetch`, {
        isInternal: true,
        data: {
          cokitchen_ids: ids
        }
      });
      setPolygons(res.data.data);
    } catch (error) {
      setPolygons([]);
      handleApiError(error);
    }
  };

  return (
    <DashboardContext.Provider
      value={{
        activeCokitchen,
        setActiveCokitchen,
        searchValue,
        setSearchValue,
        rightSection,
        setRightSection,
        isRightSectionWide,
        setIsRightSectionWide,
        showMobileSidebar,
        setShowMobileSidebar,
        cokitchens,
        setCokitchens,
        polygons,
        loadPolygons,
        showStudentAmbassadorModal,
        setShowStudentAmbassadorModal
      }}>
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardProvider;
